// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".payment-option[data-v-6cb6647e] {\n  border: 1px solid #e8eef1;\n}", ""]);
// Exports
module.exports = exports;
